const setCountryDivisionList = function() {
  let country_id = $('#registration_country_id').val()
  if ($('#country_division_set_to').val() == country_id) return

  $('#registration_country_division_id').empty()
  $.get(`/country_division_select/${country_id}`, function(data) {
    $('#country_division_set_to').val(country_id)
    $('#registration_country_division_id').append(data)
    $('.country_division_div').toggle($('#registration_country_division_id').children('option').length > 1)
  })
}

const showName = function() {
  $('#collapseAddress, #collapseCourse').removeClass('show')
  $('#collapseName').addClass('show')
}

const showAddress = function() {
  $('#collapseName, #collapseCourse').removeClass('show')
  $('#collapseAddress').addClass('show')
}

const showCourse = function() {
  $('#collapseName, #collapseAddress').removeClass('show')
  $('#collapseCourse').addClass('show')
}

const validateName = function() {
  if (
    $('#registration_first_name').val().trim() != ''
    && $('#registration_family_names').val().trim() != ''
    && $('#registration_request_origin_id').val() != ''
    && $('#registration_country_id').val() != ''
  ) {
    $('#name-next').removeAttr('disabled').removeClass('disabled')
  } else {
    $('#name-next').attr('disabled', true).addClass('disabled')
  }
}

const validateAddress = function() {
  if ($('#registration_address_line1').val().trim() != '' && $('#registration_municipality').val().trim() != '') {
    $('#address-next').removeAttr('disabled').removeClass('disabled')
  } else {
    $('#address-next').attr('disabled', true).addClass('disabled')
  }
}

const validateCourse = function() {
  if ($('#registration_course_id').val() != '') {
    $('#submit-button').removeAttr('disabled').removeClass('disabled')
  } else {
    $('#submit-button').attr('disabled', 'disabled').addClass('disabled')
  }
}

$(document).on('click', '#name-next', function (e) {
  e.preventDefault()
  if (!$(this).is('[disabled=disabled]')) {
    showAddress()
    setCountryDivisionList()
  }
})

$(document).on('click', '#address-back', function (e) {
  e.preventDefault()
  showName()
})

$(document).on('click', '#address-next', function (e) {
  e.preventDefault()
  if (!$(this).is('[disabled=disabled]'))
    showCourse()
})

$(document).on('click', '#course-back', function (e) {
  e.preventDefault()
  showAddress()
})

$(document).on('change keyup', '#registration_first_name, #registration_family_names', validateName)
$(document).on('change', '#registration_request_origin_id, #registration_country_id', validateName)
$(document).on('change keyup', '#registration_address_line1, #registration_municipality', validateAddress)
$(document).on('change', '#registration_course_id', validateCourse)

$(function() {
  if ($('form.edit_registration').length == 0) return

  validateName()
  validateAddress()
  validateCourse()
})
